import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import AdminCalendar from './AdminCalendar';
import { PageBackdrop } from './PageBackdrop';
import './index.css';

const isAdmin =
  typeof window !== 'undefined' &&
  window.location.pathname.replace(/\/+$/, '') === '/admin';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {isAdmin ? (
      <AdminCalendar />
    ) : (
      <>
        <PageBackdrop />
        <App />
      </>
    )}
  </React.StrictMode>
);
